import { useState } from 'react'
import s from './Reports.scss'
import { Tabs } from 'components/ideal-core-ui'
import { ReportByUser } from './ReportByUser'
import { ReportByMissingTime } from './ReportByMissingTime'
import { ReportByClient } from './ReportByClient'
import { ReportByType } from './ReportByType'
import { ReportByOpportunities } from './ReportByOpportunities'
import { ReportByWorkType } from './ReportByWorkType'
import qs from 'query-string'
import { useLocation } from 'react-router'
import { utcDate } from 'utils/helpers'
import moment from 'moment'

const Reports = () => {
  const location = useLocation()
  const search = qs.parse(location.search)
  const [startDate, setStartDate] = useState(
    utcDate(moment().subtract(2, 'weeks').startOf('day').format())
  )
  const [endDate, setEndDate] = useState(utcDate(moment().add(6, 'weeks').endOf('day').format()))
  const [dateRangeOption, setDateRangeOption] = useState({ value: 'custom', label: 'Custom Dates' })

  const handleDatesShortcut = ({ value }) => {
    let newStartDate, newEndDate

    switch (value) {
      case 'lastYear':
        newStartDate = utcDate(moment().subtract(1, 'year').startOf('year').format())
        newEndDate = utcDate(moment().subtract(1, 'year').endOf('year').format())
        break

      case 'thisYear':
        newStartDate = utcDate(moment().startOf('year').format())
        newEndDate = utcDate(moment().endOf('year').format())
        break

      case 'lastMonth':
        newStartDate = utcDate(moment().subtract(1, 'month').startOf('month').format())
        newEndDate = utcDate(moment().subtract(1, 'month').endOf('month').format())
        break

      case 'thisMonth':
        newStartDate = utcDate(moment().startOf('month').format())
        newEndDate = utcDate(moment().endOf('month').format())
        break

      case 'lastWeek':
        newStartDate = utcDate(moment().subtract(1, 'week').startOf('week').format())
        newEndDate = utcDate(moment().subtract(1, 'week').endOf('week').format())
        break

      case 'thisWeek':
        newStartDate = utcDate(moment().startOf('week').format())
        newEndDate = utcDate(moment().endOf('week').format())
        break

      default:
        break
    }

    setStartDate(newStartDate)
    setEndDate(newEndDate)
  }

  return (
    <Tabs
      className={s.tabContainer}
      noPadding
      withUpdateUrl
      isSecondaryTab
      activeTabKey={search?.secondaryTab || 'by-user'}
      tabs={[
        {
          key: 'by-user',
          label: 'Time by User',
          value: (
            <ReportByUser
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDatesShortcut={handleDatesShortcut}
              dateRangeOption={dateRangeOption}
              setDateRangeOption={setDateRangeOption}
            />
          )
        },
        {
          key: 'by-client',
          label: 'Time by Client',
          value: (
            <ReportByClient
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDatesShortcut={handleDatesShortcut}
              dateRangeOption={dateRangeOption}
              setDateRangeOption={setDateRangeOption}
            />
          )
        },
        {
          key: 'by-type',
          label: 'Time by Type',
          value: (
            <ReportByType
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDatesShortcut={handleDatesShortcut}
              dateRangeOption={dateRangeOption}
              setDateRangeOption={setDateRangeOption}
            />
          )
        },
        {
          key: 'by-deal',
          label: 'Time by Opportunity',
          value: (
            <ReportByOpportunities
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDatesShortcut={handleDatesShortcut}
              dateRangeOption={dateRangeOption}
              setDateRangeOption={setDateRangeOption}
            />
          )
        },
        {
          key: 'by-service',
          label: 'Time by Type of Work',
          value: (
            <ReportByWorkType
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDatesShortcut={handleDatesShortcut}
              dateRangeOption={dateRangeOption}
              setDateRangeOption={setDateRangeOption}
            />
          )
        },
        {
          key: 'by-missing-time',
          label: 'Missing Time',
          value: (
            <ReportByMissingTime
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDatesShortcut={handleDatesShortcut}
              dateRangeOption={dateRangeOption}
              setDateRangeOption={setDateRangeOption}
            />
          )
        }
      ]}
    />
  )
}

export default Reports
